import PropTypes from 'prop-types';
import React from 'react';

import styles from './GrantCard.module.css';

function getLabels(grant) {
  const labels = [
    <li key="administration" className={styles.Label}>
      {grant.administration}
    </li>,
  ];

  if (grant.swingState) {
    labels.push(
      <li key="swingState" className={styles.Label}>
        Swing State
      </li>
    );
  }

  if (grant.competitiveRace) {
    labels.push(
      <li key="competitiveRace" className={styles.Label}>
        Competitive Race
      </li>
    );
  }

  grant.committees.forEach((c, i) => {
    labels.push(
      <li key={`committee-${i}`} className={styles.Label}>
        {c}
      </li>
    );
  });

  return labels;
}

/**
 * Reformat an ISO-8601-formatted date string.
 *
 * @return {string} The date formatted with
 *   `Date.prototype.toLocaleDateString` and options so it appears in a format
 *   like "January 1, 2019".
 */
function formatDate(ds) {
  // Split the date components and convert to numbers.
  const [year, month, day] = ds.split('-').map(bit => parseInt(bit, 10));
  // Create a new Date object. Note that the months are zero indexed.
  const d = new Date(year, month - 1, day);
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'America/Chicago',
  };
  return d.toLocaleDateString('en-US', options);
}

function getCityLabel(grant) {
  let label = `${grant.city}, ${grant.state}`;

  if (grant.city2 && grant.state2) {
    label = `${label} / ${grant.city2}, ${grant.state2}`;
  }

  return label;
}

function GrantCard({ grant }) {
  return (
    <div className={styles.GrantCard} id={`grant-${grant.id}`}>
      <h3 className={styles.Name}>{grant.projectName}</h3>
      <ul>
        <li>{formatDate(grant.awardDate)}</li>
        <li>{getCityLabel(grant)}</li>
      </ul>
      <ul>{getLabels(grant)}</ul>
      <div className={styles.Detail}>{grant.influence}</div>
    </div>
  );
}

GrantCard.propTypes = {
  grant: PropTypes.shape({
    city: PropTypes.string,
    state: PropTypes.string,
    awardDate: PropTypes.string,
    id: PropTypes.string,
    projectName: PropTypes.string,
    influence: PropTypes.string,
    administration: PropTypes.string,
  }).isRequired,
};

export default GrantCard;
